import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { LogInComponent } from './log-in/log-in.component';
import { RegisterComponent } from './register/register.component';
import { ForgotPasswordComponent } from './forgot-password/forgot-password.component';
import { TransactionsComponent } from './transactions/transactions.component';
import { BuyTokensComponent } from './buy-tokens/buy-tokens.component';
import { ReferralsComponent } from './referrals/referrals.component';
import { ProfileSettingsComponent } from './profile-settings/profile-settings.component';
import { MainComponent } from './main/main.component';
import { PurchaseOrderComponent } from './purchase-order/purchase-order.component';
import { MailotpComponent } from './mailotp/mailotp.component';
import { NotfoundComponent } from './notfound/notfound.component';
import { KycComponent } from './kyc/kyc.component';
import { EmailactivationComponent } from './emailactivation/emailactivation.component';
import { ResendactivationmailComponent } from './resendactivationmail/resendactivationmail.component';
import { PasswordresetComponent } from './passwordreset/passwordreset.component';
import { AirdropComponent } from './airdrop/airdrop.component';
import { AirdropotpComponent } from './airdropotp/airdropotp.component';



const routes: Routes = [
    { path: '', component: LogInComponent},
    { path: 'login', component: LogInComponent},
    { path: 'otpverification', component:MailotpComponent},
    { path: 'register', component: RegisterComponent},
    { path: 'emailactivation', component: EmailactivationComponent},
    { path: 'forgotpassword', component: ForgotPasswordComponent},
    { path: 'resendactivation', component: ResendactivationmailComponent},
    { path: 'passwordreset', component: PasswordresetComponent},
    
    { path: 'main', component: MainComponent, children: [
        { path: 'transactions', component: TransactionsComponent},
        { path: 'buytokens', component: BuyTokensComponent},
        { path: 'airdrop', component: AirdropComponent },
        { path: 'airdropotp', component: AirdropotpComponent },
        { path: 'referrals', component: ReferralsComponent},
        { path: 'profilesettings', component: ProfileSettingsComponent},
        { path: 'kyc', component: KycComponent},
        { path: 'purchaseorder', component: PurchaseOrderComponent}
    ]},    
    { path: '**', component: LogInComponent}

];
@NgModule({
    imports: [
        RouterModule.forRoot(routes, {useHash: true})],
    exports: [RouterModule]
})
export class AppRoutingModule {}
